// extracted by mini-css-extract-plugin
export default {"container":"ShipmentFilterPanelCheckboxSection_container__LGj-e","checkboxesContainer":"ShipmentFilterPanelCheckboxSection_checkboxesContainer__Q3ErY"};